<script>
  import { portal_url } from "./stores.js";
  import { query } from "./stores.js";
  import { get_parameters } from "./helpers";
  import { onDestroy } from "svelte";
  // First search result is from year 2006.
  let options = [];
  let option_ids = [];
  let this_year = new Date().getFullYear();
  let total = 0;
  for (let i = this_year; i >= 2006; i--) {
    option_ids.push(i);
    options.push({ year: i });
  }

  // By default we search all
  let chosen = null;
  // But check the current url.
  let params = (new URL(document.location)).searchParams;
  if (params.has("effective")) {
    chosen = Number(params.get("effective"));
  };
  $: {
    // This 'magically' gets run whenever 'chosen' changes.
    // See https://svelte.dev/tutorial/reactive-declarations
    if (chosen) {
      // We have special handing in helpers.js.
      query.effective = chosen;
    } else {
      delete query.effective;
    }
    query.set(query);
  }

  // Remember which facet search we used for the count we show currently.
  // We use this to avoid sending the same query multiple times.
  let current_search_parameters = [];
  const facet_search = async () => {
    let search_url = $portal_url + "/@minaraad_search_facets";
    let facet_query = {};
    Object.assign(facet_query, $query);
    // We don't need to pass values for effective: the Python code already knows what to do.
    Object.assign(facet_query, { facet: "effective" });
    let parameters = get_parameters(facet_query);
    // https://stackoverflow.com/questions/7837456/how-to-compare-arrays-in-javascript#19746771
    if (
      parameters.length === current_search_parameters.length &&
      parameters.every(function (value, index) {
        return value === current_search_parameters[index];
      })
    ) {
      return;
    }
    current_search_parameters = parameters;
    search_url += "?" + parameters.join("&");
    const res = await fetch(search_url, {
      headers: new Headers({ Accept: "application/json" }),
    });
    let results = await res.json();
    let items = results.items;
    if (items === undefined) {
      return;
    }
    total = 0;
    options.forEach((option) => {
      option.count = 0;
      items.forEach((element) => {
        let facet = element.facet;
        if (option.year === facet) {
          option.count += element.count;
          total += element.count;
        }
      });
    });
    options = options;
  };

  // Subscribe to changes of query,
  // and make sure we unsubscribe when we are destroyed.
  const unsubscribe_query = query.subscribe((value) => {
    facet_search();
  });
  onDestroy(unsubscribe_query);
</script>

<div class="faceted-widget">
  <fieldset class="widget-fieldset">
    <legend>Jaar</legend>
    <select bind:value={chosen} on:blur={facet_search}>
      <option value>Totaal ({total})</option>
      {#each options as { year, count }}
        <option value={year}>{year} ({count})</option>
      {/each}
    </select>
  </fieldset>
</div>


